
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { MatDialog} from '@angular/material/dialog';
import {first, map, switchMap} from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { Observable, of, Subject } from 'rxjs';
import { LoggingService } from 'src/app/shared/services/Logging.service';


interface User {
  pageID?: string[];
  id: string;
  totalBilling?: string;
  email: string;
  displayName?: string;
  cell?: string;
  role?: string;
  photoURL?: string;
  resumeURL?: string;
  nationalId?: string;
  gender?: string;
  skills?: string[];
  operations?: any[];
  shops?:{};
  themes?:string[];
  customer_id_stripe?:any;
  platform?:any;
  emailVerified?:any;
  userLogin?: any 
}

@Injectable()
export class AuthService {

  user!: any ;
  redirectRouteSnapshot: ActivatedRouteSnapshot | undefined;
  userData: any; 
  private logoutSubject = new Subject<void>();
  logout$ = this.logoutSubject.asObservable();
  constructor(private loggingService: LoggingService,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
  ) {
      this.afAuth.setPersistence('local');
      // this.user = this.afAuth.authState.pipe(
      //   switchMap(user => {
          
      //     if (user) {
      //         return this.afs.doc<User>(`users/${user.uid}`).snapshotChanges().pipe(
      //           map(
      //             a => {
                    
      //               const data = a.payload.data() as any;
      //               const id = a.payload.id;
      //               const path = a.payload.ref.path;
      //               return {id, path, ...data};
      //             }));   
      //     } else {
      //       return of(null);
      //     }
      //   }));
  }

  // doVerifyEmail() {
  //   //return this.afAuth.sendEmailVerification();//this.afAuth.currentUser.sendEmailVerification();
  //   return this.afAuth.currentUser.then(u => u.sendEmailVerification());
  // }
  

  triggerLogout(): Promise<void> {
    return new Promise((resolve) => {
      this.logoutSubject.next();
      this.loggingService.log('Sidebar cleaned up');
      resolve();
    });
  }
  
  currentUser() {
  return this.afAuth.currentUser;
  }
  getUser(): Observable<any> | null {
    return this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          return this.afs.doc<User>(`users/${user.uid}`).snapshotChanges().pipe(
            map((a) => {
              const data = a.payload.data() as any;
              const id = a.payload.id;
              const path = a.payload.ref.path;
              return { id, path, ...data };
            })
          );
        } else {
          return of(null); // Return an observable with null
        }
      })
    );
  }
  async doEmailLogin(email : string , password : string  ,rememberMe : string ) {
  
    return this.afAuth.signInWithEmailAndPassword(email, password).then((result) => {
      //this.loggingService.log('result',result)
      return result
      //this.SetUserData(result.user);
      /*this.afAuth.authState.subscribe((user) => {
        //this.loggingService.log('user',user)
         return user
      });*/
    })
    // .catch((error: any) => {
    //   window.alert(error.message);
    // });
  }

  AuthLogin(provider : any) {
    provider.setCustomParameters({ display: 'popup' })
    return this.afAuth
      .signInWithPopup(provider)
      .then((result) =>{
        return result
       })
  }


   // Send email verfificaiton when new user sign up
   SendVerificationMail(email) {
    return this.afAuth.currentUser
      .then((u: any) =>  
        u.sendEmailVerification({url: 'https://dev.conversell.ai/auth/signup-details', handleCodeInApp: true,} ))
      .then(() => {
        window.localStorage.setItem('emailForSignIn', email); 
       this.router.navigate(['auth/email-verification']);
      });
  }

  SetUserData(user: any, userLogin : any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );
    const userData: User = {
      id: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified,
      userLogin : userLogin
    };

    return userRef.set(userData, {
      merge: true,
    })

  }
  SetUserDataAmazon(user: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );
    const userData: User = {
      id: user.id,
      email: user.email,
      displayName: user.name,
    };

    return userRef.set(userData, {
      merge: true,
    });
  }

  SignUpWithEmail(email : string , password: string ) {
    return this.afAuth
    .createUserWithEmailAndPassword(email, password)
    .then((result) => {
      //this.SendVerificationMail(email);
      this.SetUserData(result.user,'basic');
      return result
    })
    .catch((error) => {
      throw error
    });
  }

  doResetPassword(email: string ){
    return this.afAuth.sendPasswordResetEmail(email);
  }

  doTokenLogin(token: string ) {
    return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .then(() => {
      return this.afAuth.signInWithCustomToken(token);
    })
    .catch((error: any ) => {
      var errorCode = error.code;
      var errorMessage = error.message;
    })
   
  }
  doTokenLoginShopify(token: string): Promise<any> {
    return firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        return this.afAuth.signInWithCustomToken(token);
      })
      .then((result) => {
        return this.afs
          .doc<User>(`users/${result.user?.uid}`) // Retrieve user details from Firestore
          .valueChanges()
          .pipe(first())
          .toPromise()
          .then((userData) => {
            if (userData) {
              // Store user data in local storage
              localStorage.setItem('user', JSON.stringify(userData));
              return userData; // Return the user data including the role
            } else {
              throw new Error('User data not found in Firestore');
            }
          });
      })
      .catch((error) => {
        console.error('Error during token login:', error);
        throw error;
      });
  }
  


  async doSignout() {
     await this.afAuth.signOut().then(
      () => {
        this.redirectRouteSnapshot = undefined;
        this.loggingService.log('logged out');
        this.snackBar.open('Logged out', '', {duration: 4000});
       }
    ).catch(
      e => {
        this.loggingService.log('logged out catch');
        this.snackBar.open('Error', '', {duration: 4000});
        });
  }

 

  private updateUserData(user: any ) {
    // Sets user data to firestore on student-login
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const data: User = {
      id: user.id,
      pageID: user.pageID ,
      role: user.role,
      email: user.email,
      totalBilling:"0",
      cell: user.cell,
      displayName: user.displayName,
      photoURL: user.photoURL,
      shops:user.shops,
      themes:user.themes,
      customer_id_stripe:user.customer_id_stripe,
      platform:user.platform,   }
    return userRef.set(data);
  }
  signOut() {
    this.afAuth.signOut().then(() => {
     
      this.router.navigate(['auth', 'login']);
      this.snackBar.open('You have disconnected from your account', '', {
        duration: 2000
       });
    });
  }
  isLoggedIn() {
    return this.afAuth.authState.pipe(first()).toPromise();
   } 
  checkAccountEmailExistInFirebase(email: string) : Promise<boolean>   {
   return firebase.auth().fetchSignInMethodsForEmail(email).then(function (signInMethods) {
      if (signInMethods.length > 0) {
        return true;
      }
      return false;
    });
 }
}


